import { Stack, Typography } from "@mui/material"

export function RateCardAutocompleteOption(props, option) {
    return (
        <li {...props} key={option.id}>
            <Stack>
                <Typography variant="body2">{option.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                    {option.currency || "GBP"} &middot; {option.skillMapName || "No skill map"}
                </Typography>
            </Stack>
        </li>
    )
}
